import { render, staticRenderFns } from "./SdfPagination.vue?vue&type=template&id=5bd6a890"
import script from "./SdfPagination.vue?vue&type=script&lang=js"
export * from "./SdfPagination.vue?vue&type=script&lang=js"
import style0 from "./SdfPagination.vue?vue&type=style&index=0&id=5bd6a890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports